(() => {
  const nav = document.querySelector('.lps-nav');
  if (!nav || nav.dataset.ready) return;
  nav.dataset.ready = 'true';
  document.body.classList.add('lps-page');
  const slot = nav.parentElement;
  const links = [...nav.querySelectorAll('a')];
  const buy = document.querySelector('.lps-buy-anchor');
  // The video can sit between the story and the original product section.
  const picker = document.querySelector('block-variant-picker');
  const productSection = picker?.closest('.shopify-section');
  productSection?.classList.add('lps-buy-section');
  if (buy && picker) picker.before(buy);
  const previewView = new URL(location.href).searchParams.get('view');
  function preservePreviewView() {
    if (!previewView) return;
    const url = new URL(location.href);
    if (url.searchParams.get('view') === previewView) return;
    url.searchParams.set('view', previewView);
    history.replaceState(history.state, '', url);
  }
  const sizeData = document.querySelector('[data-story-variants]');
  const data = sizeData ? JSON.parse(sizeData.textContent) : null;
  const details = new Map((document.querySelector('[data-story-size-details]')?.textContent || '').split('\n').map(line => {
    const [name, dimension, note] = line.split('|').map(value => value.trim());
    return [name, {dimension, note}];
  }));
  const buyingHeading = document.querySelector('[data-story-buying-heading]')?.textContent.trim();
  const title = productSection?.querySelector('h1');
  if (buy && title) title.before(buy);
  const packageText = document.querySelector('[data-story-package]')?.textContent.trim().split(/\n\s*\n/)[0];
  const gallery = productSection?.querySelector('product-images');
  if (gallery && packageText) {
    const packageNote = document.createElement('p');
    packageNote.className = 'lps-package-note';
    packageNote.textContent = packageText;
    gallery.after(packageNote);
  }
  if (title && buyingHeading) {
    const originalTitle = document.createElement('p');
    originalTitle.className = 'lps-original-title';
    originalTitle.textContent = title.textContent.trim();
    title.textContent = buyingHeading;
    title.after(originalTitle);
  }
  const selectionNote = document.createElement('p');
  selectionNote.className = 'lps-selected-note';
  selectionNote.setAttribute('aria-live', 'polite');
  picker?.after(selectionNote);
  function enhanceSizes() {
    if (!data?.singleOption || !picker) return;
    picker.classList.add('lps-size-picker');
    picker.querySelectorAll('label.element-radio').forEach(label => {
      const input = label.querySelector('input');
      const button = label.querySelector('button');
      const variant = data.variants.find(item => item.title === input?.value);
      if (!variant || !button || button.dataset.storyCard) return;
      button.dataset.storyCard = 'true';
      const fact = details.get(variant.title);
      const add = (className, value) => {
        if (!value) return;
        const span = document.createElement('span');
        span.className = className;
        span.textContent = value;
        button.append(span);
      };
      button.setAttribute('title', [variant.title, fact?.dimension].filter(Boolean).join(' · '));
      add('lps-size-dimension', fact?.dimension);
      if (!variant.available) add('lps-size-note', 'Unavailable');
    });
  }
  function syncWhatsApp() {
    if (!data?.singleOption || !productSection) return;
    const name = picker?.querySelector('input:checked')?.value;
    const variant = data.variants.find(item => item.title === name);
    if (!variant) return;
    const fact = details.get(name);
    const noteText = [fact?.dimension, fact?.note].filter(Boolean).join(' · ');
    if (selectionNote.textContent !== noteText) selectionNote.textContent = noteText;
    productSection.querySelectorAll('a[href*="wa.me/"]').forEach(link => {
      const url = new URL(link.href);
      const current = new URL(location.href);
      current.search = '';
      current.hash = '';
      current.searchParams.set('variant', variant.id);
      url.searchParams.set('text', `I'm interested in ${name}. ${current.href}`);
      link.href = url.href;
    });
  }
  enhanceSizes(); syncWhatsApp();
  picker?.addEventListener('change', () => { enhanceSizes(); syncWhatsApp(); });
  if (productSection) new MutationObserver(() => { enhanceSizes(); syncWhatsApp(); preservePreviewView(); }).observe(productSection, {childList:true,subtree:true});
  links.forEach(link => {
    const target = document.getElementById(link.hash.slice(1));
    if (!target) { link.hidden = true; return; }
    link.addEventListener('click', event => {
      event.preventDefault();
      if (target.classList.contains('lps-details')) target.querySelector('details')?.setAttribute('open','');
      const top = target.getBoundingClientRect().top + window.scrollY - nav.offsetHeight - 18;
      window.scrollTo({top,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    });
  });
  let pending = false;
  function update() {
    pending = false;
    slot.style.height = `${nav.offsetHeight}px`;
    const fixed = slot.getBoundingClientRect().top <= 0;
    nav.classList.toggle('is-fixed', fixed);
    document.body.classList.toggle('lps-nav-active', fixed);
    const targets = links.filter(link => !link.hidden).map(link => ({link,target:document.getElementById(link.hash.slice(1))})).sort((a,b)=>a.target.getBoundingClientRect().top-b.target.getBoundingClientRect().top);
    let current = targets[0]?.link;
    for (const item of targets) if (item.target.getBoundingClientRect().top <= nav.offsetHeight + 120) current = item.link;
    for (const link of links) { if (link === current) link.setAttribute('aria-current','location'); else link.removeAttribute('aria-current'); }
  }
  window.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true});
  window.addEventListener('resize',update);
  update();
})();
